import React from 'react';

import { MedicationFollowupMessageOnAllPatientListFragment } from '~/graphql/generated/graphql';

export const MessageSendFromColumn = ({
  latestFollowupMessage,
}: {
  latestFollowupMessage: MedicationFollowupMessageOnAllPatientListFragment | null;
}) => {
  if (!latestFollowupMessage) {
    return <>-</>;
  }

  return (
    <>
      {latestFollowupMessage.practitioner.familyName} {latestFollowupMessage.practitioner.givenName}
    </>
  );
};
